import { useDispatch } from 'react-redux';

import { RetrieveCompanyInputDto, RetrieveCompanyOutputDto } from '@api/ecommerce-xp';
import { useFetch } from '@hooks';
import { saveSuccessServiceResponse } from '@store';

export const useFetchRetrieveCompany = () => {
	const dispatch = useDispatch();

	return useFetch<RetrieveCompanyInputDto, RetrieveCompanyOutputDto>({
		operationKey: 'retrieveCompany',
		withLoading: false,
		onSuccess: (res) => res && dispatch(saveSuccessServiceResponse({ retrieveCompany: res.data })),
	});
};
